module.exports = "/images/vendor/flag-icon-css/flags/1x1/dj.svg?0c386d224ea283b79429a3097c055388";